import {
  Checkbox,
  FormControlLabel,
  Grid,
  styled,
  TableBody,
  TableCell,
  TableContainer as MTableContainer,
  TableHead,
  TableRow,
  Container,
} from "@mui/material";
import React from "react";
import {
  Button,
  Card,
  Form,
  GoBack,
  IconButton,
  Text,
  Title,
  Tooltip,
} from "../../../../components";
import {
  ControlledTextField,
  ControlledAutoComplete,
  PercentTextField,
} from "../../../../components/inputs";
import {
  BodyTableRow,
  SizedTableCell,
  Table,
} from "../../../../components/tables";
import {
  AccountTextField,
  IntegerTextField,
} from "../../../../components/inputs";
import useResponsive from "../../../../hooks/useResponsive";
import ControlledCheckbox from "../../../../components/inputs/ControlledCheckbox";
import { HelpOutline, HelpOutlineOutlined } from "@mui/icons-material";
import { transientOptions } from "../../../../styles/theme";

const TableContainer = styled(MTableContainer)`
  & .MuiTable-root {
    margin-top: 0;
  }

  & .MuiTableHead-root .MuiTableCell-head {
    padding-top: 0;
  }
`;
const ContaContainer = styled(Grid)`
  border: 1px solid ${({ theme }) => theme.colors.grey._50};
  border-radius: 1rem;
  padding: 1rem;
`;

const formatWithCodeAndDescription = (option, domain) => {
  if (!!option) {
    const domainOption = domain.find(
      (d) => d.id === option.id || d.id === option
    );
    if (!!domainOption) {
      return `${domainOption.codigo} - ${domainOption.nome}`;
    }
  }
  return "";
};

const ContasMobile = ({
  contas,
  bancos,
  formProps,
  tiposConta,
  toggleHabilitado,
}) => {
  return (
    <Grid container spacing={1}>
      {contas.map((conta, index) => (
        <Grid item key={index}>
          <ContaContainer>
            <Grid item container spacing={2}>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <ControlledCheckbox
                      formProps={formProps}
                      name={`contas.${index}.habilitado`}
                      checked={conta.habilitado}
                      onChange={() => toggleHabilitado(index)}
                    />
                  }
                  label={conta.nome}
                />
              </Grid>
              <Grid item xs={12}>
                <ControlledAutoComplete
                  domain={bancos}
                  label={"Banco"}
                  idField={"id"}
                  getOptionLabel={(option) =>
                    formatWithCodeAndDescription(option, bancos)
                  }
                  name={`contas.${index}.bancoConta`}
                  formProps={formProps}
                  readOnly={!conta.habilitado}
                  autocompleteProps={{
                    clearText: "Limpar",
                    loadingText: "Carregando opções",
                    noOptionsText: "Nenhuma opção disponível",
                  }}
                />
              </Grid>
              <Grid item xs={5}>
                <ControlledTextField
                  label={"Agência"}
                  name={`contas.${index}.agenciaConta`}
                  inputProps={{
                    maxLength: 4,
                    allowLeadingZeros: true,
                    asString: true,
                    allowNegative: false,
                  }}
                  formProps={formProps}
                  InputProps={{
                    readOnly: !conta.habilitado,
                    inputComponent: IntegerTextField,
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <ControlledTextField
                  label={"Conta"}
                  name={`contas.${index}.numeroConta`}
                  formProps={formProps}
                  InputProps={{
                    readOnly: !conta.habilitado,
                    inputComponent: AccountTextField,
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ControlledAutoComplete
                  domain={tiposConta}
                  idField={"id"}
                  label={"Tipo"}
                  labelField={"descricao"}
                  name={`contas.${index}.tipoConta`}
                  formProps={formProps}
                  readOnly={!conta.habilitado}
                  autocompleteProps={{
                    clearText: "Limpar",
                    loadingText: "Carregando opções",
                    noOptionsText: "Nenhuma opção disponível",
                  }}
                />
              </Grid>
            </Grid>
          </ContaContainer>
        </Grid>
      ))}
    </Grid>
  );
};

const ContasDesktop = ({
  contas,
  bancos,
  formProps,
  tiposConta,
  toggleHabilitado,
}) => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <SizedTableCell width={56}></SizedTableCell>
            <TableCell width={"25%"}>Nome</TableCell>
            <TableCell width={"25%"}>Banco</TableCell>
            <TableCell width={"10%"}>Agência</TableCell>
            <TableCell width={"15%"}>Conta</TableCell>
            <TableCell width={"15%"}>Tipo</TableCell>
            <TableCell width={"10%"}>% liberação</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contas.map((conta, index) => {
            return (
              <BodyTableRow key={index} index={index}>
                <SizedTableCell width={56}>
                  <ControlledCheckbox
                    formProps={formProps}
                    name={`contas.${index}.habilitado`}
                    checked={conta.habilitado}
                    onChange={() => toggleHabilitado(index)}
                  />
                </SizedTableCell>
                <TableCell>{conta.nome}</TableCell>
                <TableCell>
                  <ControlledAutoComplete
                    domain={bancos}
                    idField={"id"}
                    getOptionLabel={(option) =>
                      formatWithCodeAndDescription(option, bancos)
                    }
                    name={`contas.${index}.bancoConta`}
                    formProps={formProps}
                    readOnly={!conta.habilitado}
                    autocompleteProps={{
                      clearText: "Limpar",
                      loadingText: "Carregando opções",
                      noOptionsText: "Nenhuma opção disponível",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <ControlledTextField
                    name={`contas.${index}.agenciaConta`}
                    inputProps={{
                      maxLength: 4,
                      allowLeadingZeros: true,
                      asString: true,
                      allowNegative: false,
                    }}
                    formProps={formProps}
                    InputProps={{
                      readOnly: !conta.habilitado,
                      inputComponent: IntegerTextField,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <ControlledTextField
                    name={`contas.${index}.numeroConta`}
                    formProps={formProps}
                    InputProps={{
                      readOnly: !conta.habilitado,
                      inputComponent: AccountTextField,
                    }}
                  />
                </TableCell>
                <TableCell>
                  <ControlledAutoComplete
                    domain={tiposConta}
                    idField={"id"}
                    labelField={"descricao"}
                    name={`contas.${index}.tipoConta`}
                    formProps={formProps}
                    readOnly={!conta.habilitado}
                    autocompleteProps={{
                      clearText: "Limpar",
                      loadingText: "Carregando opções",
                      noOptionsText: "Nenhuma opção disponível",
                    }}
                  />
                </TableCell>
                <TableCell>
                  <ControlledTextField
                    name={`contas.${index}.percentualLiberacao`}
                    formProps={formProps}
                    onChange={() => formProps.formState.isSubmitted && formProps.trigger()}
                    InputProps={{
                      readOnly: !conta.habilitado,
                      inputComponent: PercentTextField,
                    }}
                  />
                </TableCell>
              </BodyTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const HelpBox = styled('div', transientOptions)`
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 3px;
  color: ${({ theme, _color_ = "info" }) =>
    _color_ === "grey" ? theme.colors.grey._200 : theme.colors[_color_]._600};
  margin-top: ${({ _color_ = "info" }) =>
    _color_ === "grey" ? "-3px" : "3px"};
  & .MuiSvgIcon-root {
    font-size: ${({ theme }) => theme.fonts.size.default};
  }
  & p {
    font-size: ${({ theme }) => theme.fonts.size.default};
    margin-left: 0.5rem;
    color: ${({ theme, _color_ = "info" }) =>
      _color_ === "grey" ? theme.colors.grey._200 : theme.colors[_color_]._600};
  }
`;

const ContasLiberacaoVendedorSantanderForm = ({
  formProps,
  handleSubmit,
  contas,
  bancos,
  tiposConta,
  submitting,
  handleGoBack,
  toggleHabilitado,
}) => {
  const currentSize = useResponsive();
  const isMobile = currentSize === "xs" || currentSize === "sm";

  return (
    <>
      <GoBack
        handleClick={handleGoBack}
        text={"Selecione ao menos uma conta para receber o valor do imóvel"}
      />
      <Grid item container spacing={3}>
        <Grid item container justifyContent={"center"}>
          <Grid item xs={12} xl={8}>
            <Card>
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    display={"flex"}
                    justifyContent={"space-between"}
                  >
                    <Grid
                      container
                      display={"flex"}
                      justifyContent={"space-between"}
                    >
                      <Grid item>
                        <Title as={"h3"}>Contas para Liberação</Title>
                      </Grid>
                      <Tooltip
                        title="Marque a caixa de seleção das contas de liberação que você deseja preencher. A soma dos percentuais precisa resultar em 100%."
                        arrow
                      >
                        <Grid item display={"flex"} flexDirection={"row"}>
                          <HelpBox>
                            <Text>Ajuda</Text>
                            <HelpOutline />
                          </HelpBox>
                        </Grid>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    {!!isMobile && (
                      <ContasMobile
                        contas={contas}
                        formProps={formProps}
                        tiposConta={tiposConta}
                        bancos={bancos}
                        toggleHabilitado={toggleHabilitado}
                      />
                    )}
                    {!isMobile && (
                      <ContasDesktop
                        contas={contas}
                        formProps={formProps}
                        tiposConta={tiposConta}
                        bancos={bancos}
                        toggleHabilitado={toggleHabilitado}
                      />
                    )}
                  </Grid>
                  <Grid item container justifyContent={"center"} mt={1}>
                    <Grid item xs={12} md={4}>
                      <Button
                        type={"submit"}
                        fullWidth
                        disabled={
                          contas.filter((x) => !!x && x.habilitado).length === 0
                        }
                        loading={submitting}
                      >
                        CONTINUAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ContasLiberacaoVendedorSantanderForm;
